import { useEffect, useState} from 'react';
import {breakPoints} from '../theme/theme'

const useView = () => {
    
    const [width, setWidth] = useState(window.innerWidth);
    // Add a second state variable "height" and default it to the current window height
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleWindowResize = () => {
        setWidth(window.innerWidth);
        // Set the height in state as well as the width
        setHeight(window.innerHeight);
    }

        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    let display;

    if(width < breakPoints.sm){
        display  = "mobile"
    }
    if(width >= breakPoints.sm  && width < breakPoints.md){
        display  = "tablet"
    }
    if (width >= breakPoints.md){
        display  = "desktop"
    }

    return { width, height, display };
}

export default useView
